import React from 'react';
import { ConfirmModal } from 'components/shared/ConfirmModal';

export const DeletePaymentModal = ({ show, transaction, confirmState, isLoading, onConfirm, onClose = () => {} }) => {
  const messages = {
    pending: {
      title: "Delete Payment Link",
      description: "Are you sure you want to delete this manual/offline payment? This will remove the transaction record and cannot be undone.",
      actionText: "Yes, Delete",
    },
    success: {
      title: "Payment Deleted",
      description: "The payment record has been successfully deleted.",
      actionText: "Done",
    },
  };

  return (
    <ConfirmModal
      show={show}
      messages={messages}
      onOk={onConfirm}
      onClose={onClose}
      state={confirmState}
      confirmLoading={isLoading}
    />
  );
};
